import React from 'react';
export const FleetDashboard = React.lazy(() => import('./FleetDashboard.jsx'));